import {makeGetCityLocation} from 'main/factories/usecases/private/booking-flow/remote-health-booking/get-city-location-factory';
import {makeGetHealthVerifySpecialties} from 'main/factories/usecases/private/booking-flow/remote-health-booking/get-health-verify-specialties-factory';

import {GetCityLocationAndVerifySpecialtiesParams} from './types';
import {FlowEnum} from '../../constants/flowEnum';

async function getCityLocationAndVerifySpecialties({
	flowType,
	latitude,
	longitude,
	signal,
}: GetCityLocationAndVerifySpecialtiesParams) {
	const isExamFlow = flowType === FlowEnum.EXAM;
	const isOdontoFlow = flowType === FlowEnum.ODONTO;

	if (!latitude || !longitude) throw new Error('Invalid location');

	const locationName = `${latitude},${longitude}`;

	const cityLocationParams = {
		latitude,
		longitude,
		signal,
	};

	const verifySpecialtiesParams = {locationName, signal};

	return Promise.all(
		isExamFlow || isOdontoFlow
			? [makeGetCityLocation().get(cityLocationParams)]
			: [
					makeGetCityLocation().get(cityLocationParams),
					makeGetHealthVerifySpecialties().get(verifySpecialtiesParams),
				],
	);
}

export {getCityLocationAndVerifySpecialties};
